export default function StickyActions({ left, right }) {
  return (
    <div className="sticky bottom-0 z-30 mt-6">
      <div className="flex flex-col gap-3 rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),0.95)] px-4 py-3 shadow-sm backdrop-blur sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-2">{left}</div>
        <div className="flex flex-wrap items-center gap-2">{right}</div>
      </div>
    </div>
  );
}
